import React, { useState } from 'react'
import {
	Dialog,
	DialogTitle,
	DialogContent,
	Grid,
	Typography,
	useTheme,
	IconButton,
	Button,
	CircularProgress,
	Box
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Email from './app/fields/email'
import Firstname from './app/fields/firstname'
import Lastname from './app/fields/lastname'
import Telno from './app/fields/telno'
import addToMailchimp from 'gatsby-plugin-mailchimp'
import { useForm } from 'react-hook-form'

const MailChimp = () => {
	const theme = useTheme()
	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm()
	const [open, setOpen] = useState(false)
	const [feedback, setFeedback] = useState('')
	const [unsavedChanges, setUnsavedChanges] = useState(false)
	const [loading, setLoading] = useState(false)
	const [firstname, setFirstname] = useState('')
	const [lastname, setLastname] = useState('')
	const [email, setEmail] = useState('')
	const [telno, setTelno] = useState('')

	const initState = () => {
		setFeedback('')
		setUnsavedChanges(false)
		setLoading(false)
		setFirstname('')
		setLastname('')
		setEmail('')
		setTelno('')
	}

	const handleClickOpen = () => {
		setOpen(true)
	}

	const handleClose = () => {
		initState()
		setOpen(false)
	}

	const handleUpdateFirstname = (event) => {
		setUnsavedChanges(true)
		setFirstname(event.target.value)
	}

	const handleUpdateLastname = (event) => {
		setUnsavedChanges(true)
		setLastname(event.target.value)
	}

	const handleUpdateEmail = (event) => {
		setUnsavedChanges(true)
		setEmail(event.target.value)
	}

	const handleUpdateTelno = (event) => {
		setUnsavedChanges(true)
		setTelno(event.target.value)
	}

	const handleSubmitChimp = () => {
		setLoading(true)
		addToMailchimp(email, {
			FNAME: firstname,
			LNAME: lastname,
			PHONE: telno
		})
			.then(({ msg, result }) => {
				setLoading(false)
				setUnsavedChanges(false)
				if (result !== 'success') {
					throw msg
				}
				setFeedback(msg)
			})
			.catch((err) => {
				setLoading(false)
				setUnsavedChanges(false)
				console.log('err', err)
				setFeedback(err)
			})
	}

	return (
		<>
			{open ? (
				<Dialog onClose={handleClose} aria-labelledby='simple-dialog-title' open={open}>
					<DialogTitle id='simple-dialog-title' disableTypography>
						<Typography component='h6' variant='h6' color='textSecondary'>
							Newsletter
						</Typography>
						<IconButton
							aria-label='close'
							sx={{
								position: 'absolute',
								right: theme.spacing(1),
								top: theme.spacing(1),
								color: theme.palette.grey[500]
							}}
							onClick={handleClose}
						>
							<CloseIcon />
						</IconButton>
					</DialogTitle>
					<DialogContent dividers>
						{feedback !== '' ? (
							<Typography component='h6' variant='h6'>
								<Box dangerouslySetInnerHTML={{ __html: feedback }} />
							</Typography>
						) : (
							<Grid container spacing={3}>
								<Grid item xs={12}>
									Please fill in the fields below
								</Grid>
								<Grid item xs={12} sm={6}>
									<Firstname
										handleOnChange={handleUpdateFirstname}
										error={errors.firstname}
										register={register}
										value={firstname}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Lastname
										handleOnChange={handleUpdateLastname}
										error={errors.lastname}
										register={register}
										value={lastname}
									/>
								</Grid>
								<Grid item xs={12}>
									<Email
										handleOnChange={handleUpdateEmail}
										error={errors.email}
										register={register}
										value={email}
										withIcon
									/>
								</Grid>
								<Grid item xs={12}>
									<Telno handleOnChange={handleUpdateTelno} register={register} value={telno} withIcon />
								</Grid>
								<Grid item xs={12}>
									<Box sx={{ position: 'relative' }}>
										<Button
											size='medium'
											type='submit'
											variant='contained'
											color='secondary'
											sx={{ boxShadow: 'none', mt: '6px' }}
											onClick={handleSubmit(handleSubmitChimp)}
											disabled={!unsavedChanges}
										>
											subscribe
										</Button>
										{loading && (
											<CircularProgress
												size={24}
												sx={{
													color: '#fff',
													position: 'absolute',
													top: '50%',
													left: '50%',
													marginTop: -12,
													marginLeft: -12
												}}
											/>
										)}
									</Box>
								</Grid>
							</Grid>
						)}
					</DialogContent>
				</Dialog>
			) : null}
			<Box sx={{ position: 'relative' }}>
				<Button
					size='small'
					variant='outlined'
					color='secondary'
					sx={{ boxShadow: 'none', mt: '6px' }}
					onClick={handleClickOpen}
				>
					subscribe
				</Button>
			</Box>
		</>
	)
}

export default MailChimp
